// permanently delete a batch of prompts from firestore
// used by adminpage/AdminPrompts.js, which holds this call back for a few
// seconds so the admin can undo before anything reaches the database
// note there is no soft delete: once this runs the prompts are gone, and the
// only other copy lives in the firestore backup bucket for 90 days
import { doc, deleteDoc } from 'firebase/firestore';
import { firestore } from '../firebase';
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from './asyncActions';
import { openSnackbar } from './snackbarActions';
import { DELETE_PROMPT } from './types';

// promptsToDelete is an array of { id, title }
export const deletePrompts = promptsToDelete => async dispatch => {
  if (!promptsToDelete || promptsToDelete.length === 0) return;
  dispatch(asyncActionStart());

  // allSettled so one failed delete does not abandon the rest of the batch
  const results = await Promise.allSettled(
    promptsToDelete.map(({ id }) => deleteDoc(doc(firestore, 'prompts', id)))
  );

  const failed = [];
  let deletedCount = 0;
  results.forEach((result, index) => {
    const prompt = promptsToDelete[index];
    if (result.status === 'fulfilled') {
      deletedCount += 1;
      // drop it from the prompts list in redux state
      dispatch({ type: DELETE_PROMPT, payload: { promptID: prompt.id } });
    } else {
      console.error(result.reason);
      failed.push({ prompt, reason: result.reason });
    }
  });

  if (failed.length > 0) {
    const { code, message } = failed[0].reason || {};
    dispatch(asyncActionError({ code, message }));
    const failedTitles = failed.map(({ prompt }) => prompt.title).join(', ');
    dispatch(
      openSnackbar('ErrorSnackbar', {
        message: `Could not delete ${failed.length} prompt(s): ${failedTitles}`
      })
    );
    return;
  }

  dispatch(asyncActionFinish());
  const message =
    deletedCount === 1
      ? `Deleted ${promptsToDelete[0].title}`
      : `Deleted ${deletedCount} prompts`;
  dispatch(openSnackbar('SuccessSnackbar', { message }));
};
